import { ThemeProvider as SCThemeProvider } from "styled-components";
import { FlyUIProvider, FullScreenLoader } from "@wayflyer/flyui";

export const Fallback = () => (
  <FlyUIProvider LegacySCProvider={SCThemeProvider} theme="wayflyer">
    <FullScreenLoader />
  </FlyUIProvider>
);
